import * as actions from "../actionTypes"

const initialState = {
  value: "",
}

export default function searchBar(state = initialState, action) {
  switch (action.type) {
    case actions.SET_SEARCH_VALUE: {
      return {
        ...state,
        value: action.payload.value,
      }
    }

    default:
      return state
  }
}
